module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    primary: '#002B5C',
                    secondary: '#FFD200',
                    grayblue: '#19406C',
                    darkblue: '#001E40',
                    blue: '#0164D5',
                    orange: '#CC4700',
                    green: '#15803D',
                    amber: '#D97706',
                    pink: '#DB2777',
                    rose: '#E11D48',
                    indigo: '#6366F1',
                    lime: '#65A30D',
                }
            },
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
        __dirname + '/config/**/*.{vue,js,scss,php}',
    ],
};
